// Accessible on/off switch for a single cookie category. Uses role="switch"
// with aria-checked so screen readers announce state. The "necessary" category
// passes `locked` — rendered visibly on but disabled (never interactive).

interface ConsentToggleProps {
  id: string;
  label: string;
  description: string;
  checked: boolean;
  locked?: boolean;
  onChange?: (next: boolean) => void;
}

export function ConsentToggle({ id, label, description, checked, locked, onChange }: ConsentToggleProps) {
  return (
    <div className="consent-row">
      <div className="consent-row-head">
        <span id={`${id}-label`} className="consent-row-label">{label}</span>
        <button
          type="button"
          role="switch"
          id={id}
          aria-checked={checked}
          aria-labelledby={`${id}-label`}
          aria-disabled={locked || undefined}
          disabled={locked}
          className={`consent-switch${checked ? ' on' : ''}${locked ? ' locked' : ''}`}
          onClick={() => { if (!locked) onChange?.(!checked); }}
        >
          <span className="consent-switch-thumb" aria-hidden="true" />
          <span className="sr-only">
            {locked ? `${label}: always on` : `${label}: ${checked ? 'on' : 'off'}`}
          </span>
        </button>
      </div>
      <p className="consent-row-desc">
        {description}{locked ? ' Always on.' : ''}
      </p>
    </div>
  );
}
